import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import React from 'react';
import If from '#/common/components/If';
import WOTemplateDataGrid from '../WOTemplateDataGrid';
import WOTemplateList from '../WOTemplateList';

const WOTemplate: React.FC = () => {
  const { isDesktop } = useViewport();

  return (
    <>
      <If condition={isDesktop}>
        <WOTemplateDataGrid />
      </If>
      <If condition={!isDesktop}>
        <WOTemplateList />
      </If>
    </>
  );
};

export default React.memo(WOTemplate);
